import { Injectable } from '@angular/core';

// import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { QueryService } from './query.service';
import { Material } from '../_models/material';
import { Category } from '../_models/category';
import { Store } from '../_models/store';
import { ApplicationNotificationService } from './application-notification.service';


@Injectable()
export class MaterialsService {
  public storeMaterials: Material[] = [];
  public materials: Material[] = [];
  public categories: Category[] = [];
  public stores: Store[] = [];
  public categoryName: string = '';

  constructor(private queryService: QueryService, private notificationService: ApplicationNotificationService) {
    this.getMaterials();
    this.getCategories();
    this.getStores();
  }

  getMaterials():void {
    let url = '/materials/materials/';
    this.queryService.getQuery(url).subscribe(result => this.materials = result);
  }

  getStores():void {
    let url = '/stores/';
    this.queryService.getQuery(url).subscribe(result => {
      this.stores = result;
    });
  }

  getCategoryName(category_id:string):string {
    if(this.categories.filter(cat => String(cat.id) === category_id).pop().name) {
      return this.categories.filter(cat => String(cat.id) === category_id).pop().name;
    } else {
      return '';
    }
  }

  getMaterialsFromCategory(category_id:string):void {
    this.storeMaterials = [];
    let url = '/materials/?category_id=' + category_id;
    this.queryService.getQuery(url).subscribe(result => {
      this.storeMaterials = result;
      this.categoryName = this.getCategoryName(category_id);
    });
  }

  getCategories():void {
    let url = '/materials/categories/';
    this.queryService.getQuery(url).subscribe(result => {
      this.categories = result;
    });
  }

  removeMaterial(material:Material):void {
    let url = '/materials/materials/' + material.id + '/';
    this.queryService.deleteQuery(url).subscribe(result => {
      this.getMaterials();
      if (result.status === 204) {
        this.notificationService.addGrowl('Successfully removed ' + material.name + '.');
      } else {
        this.notificationService.addGrowl('Not able to remove ' + material.name + '.');
      }
    });
  }

  patchMaterial(id: any, body: any, file: File): any {
    const url = '/materials/materials/' + id + '/';
    const payload = JSON.stringify(body);
    this.queryService.patchQuery(url, payload).subscribe(result => {
      if (file) {
        const pdfPayload = new FormData();
        pdfPayload.append('file', file);
        this.queryService.patchQueryFormData(url, pdfPayload).subscribe( extraResult => {
          console.log('Also updated pdf.', extraResult);
        });
      }
      this.getMaterials();
      this.notificationService.addGrowl('Successfully updated material.');
    });
  }

  postMaterial(body: any, file: File): any {
    const url = '/materials/materials/';
    const payload = JSON.stringify(body);
    this.queryService.postQuery(url, payload).subscribe(result => {
      const id = result['id'];
      const patchUrl = '/materials/materials/' + id + '/';
      const pdfPayload = new FormData();
      pdfPayload.append('file', file);
      this.queryService.patchQueryFormData(patchUrl, pdfPayload).subscribe(extraResult => {
        console.log('Also updated pdf.', extraResult);
      });
      this.getMaterials();
      this.notificationService.addGrowl('Successfully added material.');
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/materials.service.ts